import React from 'react';
import { TextInput } from 'react-admin';


export const HiddenInput = (props) => {
	return (
		<TextInput style={{ display: 'none' }} label={false} {...props}/>
	);
};
